import styled from 'styled-components';

const FacebookShareButtonStyled = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background-color: var(--Blue-50);

  & img {
    vertical-align: middle;
  }
`;

export default FacebookShareButtonStyled;
